import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const LineChart = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='LineChart' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,16 L8,9 L13,14 L23,4 M0,22 L23.999,22 M16,4 L23,4 L23,11' />
  </StyledIcon>
);
